export default "__VITE_ASSET__DeQFfdSW__"